import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import Login from "./pages/Login";
import UsersPage from "./pages/UsersPage";
import Header from "./components/Header"
import ChecklistsPage from "./pages/ChecklistsPage";
import AssinarChecklist from "./pages/AssinarChecklist";
import TecnicosPage from "./pages/TecnicosPage";
import TicketsPage from "./pages/TicketsPage";
import CarsPage from "./pages/CarsPage";
import Success from "./pages/Success";
import OficinasPage from "./pages/OficinasPage";
import { useState } from "react";
import NewChecklist from "./pages/NewChecklist";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import NotFound from "./pages/NotFound";
import { UserProvider } from "./context/UserContext";



function App() {
  const [canAccess, setCanAccess] = useState(false)

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnHover
        draggable
      />
      <BrowserRouter>
        <UserProvider>
          <Routes>
            <Route path="/" element={<Header />}>
              <Route index element={<UsersPage />} />
              <Route path="/checklists" element={<ChecklistsPage setCanAccess={setCanAccess} />} />
              <Route path="/tickets" element={<TicketsPage />} />
              <Route path="/cars" element={<CarsPage />} />
              <Route path="/tecnicos" element={<TecnicosPage />} />
              <Route path="/oficinas" element={<OficinasPage />} />
              <Route path="/checklist/new" element={canAccess ? <NewChecklist /> : <Navigate to="/" />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/success/:token" element={<Success />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/ass/:tipo/:token" element={<AssinarChecklist />} />
          </Routes>
        </UserProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
